import { Image, Database, Eye, Zap, Layers, MapPin } from 'lucide-react';
import { MainBodyData, KeyTakeawaysData } from './types';

export const geointContent: MainBodyData = {
  number: '04',
  title: 'Geographic Intelligence (GEOINT)',
  icon: Image,
  sections: {
    overview: "Geographic Intelligence (GEOINT) is the process of gathering information to determine a physical location. This can cover analysing metadata from photos, image reverse researching, keyword searches, and landmark identification.",
    note: "Maintain original files with no alterations to the source material to keep for evidence and documentation.",
    // investigation steps
    steps: [
      { title: "Extract Metadata", description: "Use EXIF readers to extract GPS data, timestamps, camera info. Tools: ExifTool, Jeffrey's EXIF Viewer." },
      { title: "Approximate Location", description: "Find the approximate location through metadata, landmarks, Google Maps, news articles." },
      { title: "Key Landmarks", description: "Look for distinctive buildings, monuments, signs, street names, architecture to indicate location." },
      { title: "Narrow Down", description: "Using key data points slowly move from landmarks and narrow down to a closer area. (Look at background, move to midground then foreground). Google Dork." },
      { title: "Cross-Reference", description: "Use multiple images to build a bigger picture and frame. (Different angles, timeframes, building perspectives)." },
    ],
    platforms: ["Google Maps", "Google Earth Pro", "Wikimapia", "Street View", "Mapillary", "OpenStreetMap"],
    dataPoints: [
      "Use multiple images from varied sources to create a larger picture of the location",
      "What can you see? Foreground, Background, Map Marking, Landmarks, Signs? Google Dork these!",
      "What is the context of the image?",
      "Were there past images posted which gives you an indication of a location?",
      "Sun angle analysis and shadow direction to verify location authenticity",
      "Cross-reference with satellite imagery and street-level photography"
    ]
  }
};

export const geointTakeaways: KeyTakeawaysData = {
  sectionTitle: "GEOINT",
  takeaways: [
    "Always preserve original image files with metadata intact for chain of custody",
    "Use multiple reference points to verify locations - never rely on a single landmark",
    "Analyze sun angle, shadows, and lighting conditions to confirm location authenticity",
    "Cross-reference image dates with news events, weather patterns, and seasonal markers",
    "Document entire investigation process with screenshots and source URLs",
    "Consider multiple geotagging methods for corroboration (metadata, landmarks, street view)"
  ],
  tools: [
    { name: "Google Earth Pro", category: "SATELLITE IMAGERY", description: "High-resolution satellite imagery and historical imagery access", url: "google.com/earth", icon: MapPin },
    { name: "Google Maps", category: "STREET VIEW", description: "Street-level photography and location verification", url: "google.com/maps", icon: Eye },
    { name: "Mapillary", category: "STREET IMAGERY", description: "Crowdsourced street-level photography database", url: "mapillary.com", icon: Layers },
    { name: "SunCalc", category: "SHADOW ANALYSIS", description: "Calculate sun position, shadows, and lighting angles by location and time", url: "suncalc.org", icon: Zap },
    { name: "What3Words", category: "LOCATION REFERENCE", description: "Geocoding system using 3-word addresses for precise location identification", url: "what3words.com", icon: MapPin },
    { name: "TileFinder", category: "IMAGERY SOURCES", description: "Discover satellite and aerial imagery sources globally", url: "tilefinder.org", icon: Database },
  ]
};